<template>
  <div class="device-status-wrapper">
    <div class="device-status-content">
      <div style="display: flex;">
        <!-- 禁用 -->
        <div class="device-status device-status-disabled" v-if="disabledStatus">
          <a-icon type="stop" theme="filled" class="device-status-icon" />
          <span class="device-status-text">
            {{ $t('device_status_disabled') }}
          </span>
        </div>

        <div class="status-content-parent" v-else>
          <!-- 离线 -->
          <div class="device-status device-status-offline" v-if="onlineStatus === 0">
            <a-icon type="close-circle" theme="filled" class="device-status-icon" />
            <span class="device-status-text">
              {{ $t('device_status_offline') }}
            </span>
          </div>

          <!-- 工作状态（在线才显示工作状态） -->
          <!-- 空闲 -->
          <div
            class="device-status device-status-idle"
            v-if="workStatus === 0 && onlineStatus === 1"
          >
            <a-icon type="check-circle" theme="filled" class="device-status-icon" />
            <span class="device-status-text">
              {{ $t('device_status_idle') }}
            </span>
          </div>

          <!-- 工作中 -->
          <div
            class="device-status device-status-working"
            v-else-if="workStatus >= 1 && workStatus <= 10 && onlineStatus === 1"
          >
            <a-icon type="clock-circle" theme="filled" class="device-status-icon" />
            <span class="device-status-text">
              {{ $t('device_status_working') }}({{ workStatus }})...
            </span>
          </div>

          <!-- 报错中 -->
          <div class="device-status device-status-faulted" v-else-if="workStatus === 11">
            <a-icon type="info-circle" theme="filled" class="device-status-icon" />
            <span class="device-status-text">
              {{ $t('device_status_faulted') }}
            </span>
          </div>

          <!-- 维护 -->
          <div class="device-status device-status-maintanance" v-else-if="workStatus === 12">
            <a-icon type="tool" theme="filled" class="device-status-icon" />
            <span class="device-status-text">
              {{ $t('device_status_maintain') }}
            </span>
          </div>

          <!-- 固件更新 -->
          <div class="device-status device-status-update" v-else-if="workStatus === 13">
            <a-icon type="interaction" theme="filled" class="device-status-icon" />
            <span class="device-status-text">
              {{ $t('device_status_update') }}
            </span>
          </div>

          <!-- 告警（新增一个显示区域） -->
          <div class="device-status device-status-alarm" v-if="alarmNum > 0" @click="showAlarm">
            <a-icon type="exclamation-circle" theme="filled" class="device-status-icon" />
            <span class="device-status-text">
              {{ $t('device_base_info_alarm') }}({{ alarmNum }})
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 告警数量
    alarmNum: {
      type: [Number],
      default: null,
    },
    callback: {
      type: Function,
      default: null,
    },
    // 禁用与否
    disabledStatus: {
      type: [String, Number, Object, Boolean],
      default: null,
    },
    // 在线/不在线
    // 设备是否在线，由协议通信状态决定，0-offline，1-online
    onlineStatus: {
      type: [String, Number, Object],
      default: null,
    },
    // 错误状态
    // 设备故障状态，0-无故障，1-故障不可用，2-故障，部分设备不可用，3-告警，但设备可用
    faultStatus: {
      type: [String, Number, Object],
      default: null,
    },
    // 设备运行总状态。0- 空闲可用 1~10 工作中（如充电中，10 中工作状态，具体可由设备自行定义，前端只显示工作中加上此数值即可） 11- 故障停用 12- 维护禁用中 13- 设备正在软件升级中
    workStatus: {
      type: [String, Number, Object],
      default: null,
    },
    // webui/vpn状态
    // 设备vpn状态，由协议以及nps状态决定，0-空闲，未启动vpn，1-已启动vpn但未连接到server，2-启动vpn并连接成功，99- 不支持vpn功能
    vpnStatus: {
      type: [String, Number, Object],
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    onlyOnlineOffline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    showAlarm() {
      if (this.callback && typeof this.callback === 'function') {
        if ((this.faultStatus !== 3 && this.alarmNum > 0) || this.faultStatus === 3) {
          this.callback();
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.device-status-wrapper {
  .device-status-content {
    display: flex;

    .status-content-parent {
      display: flex;
    }
    // 状态
    ::v-deep .device-status {
      color: #45454a;
      text-align: center;
      padding: 1px 4px;
      border-radius: 4px;
      height: 24px;
      white-space: nowrap;
      font-size: 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      margin-right: 8px;

      .device-status-icon {
        margin-right: 4px;
      }

      .device-status-text {
        font-size: 12px;
      }

      // 禁用
      &.device-status-disabled {
        border: 1px solid #ffa39e;
        background: #fff1f0;
        color: #f5222d;

        .device-status-icon {
          color: #f5222d;
        }
      }

      // 离线
      &.device-status-offline {
        border: 1px solid #cfcfd3;
        background: #e7e7e9;
      }

      // 空闲
      &.device-status-idle {
        border: 1px solid #d9f7be;
        background: #f6ffed;
        color: #52c41a;

        .device-status-icon {
          color: #52c41a;
        }
      }

      // 工作中
      &.device-status-working {
        border: 1px solid #e6e7f8;
        background: #f9f9fd;
        color: #1838d9;

        .device-status-icon {
          color: #1838d9;
        }
      }

      // 报错
      &.device-status-faulted {
        border: 1px solid #ffccc7;
        background: #fff1f0;
        color: #f5222d;

        .device-status-icon {
          color: #f5222d;
        }
      }

      // 告警
      &.device-status-alarm {
        border: 1px solid #ffe58f;
        background: #fffbe6;
        color: #faad14;
        cursor: pointer;

        .device-status-icon {
          color: #faad14;
        }
      }

      // 维护
      &.device-status-maintanance {
        border: 1px solid #ffe58f;
        background: #fffbe6;
        color: #faad14;

        .device-status-icon {
          color: #faad14;
        }
      }

      // 固件更新
      &.device-status-update {
        border: 1px solid #91d5ff;
        background: #e6f7ff;
        color: #1890ff;

        .device-status-icon {
          color: #1890ff;
        }
      }
    }
  }
}
</style>
